export const formatNumber = (number: number = 0, decimals: boolean = false): string =>
  number.toLocaleString('en-US', {
    maximumFractionDigits: decimals ? 2 : 0,
  });
